module.exports = __webpack_public_path__ + "static/img/sixth.ee8b254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sixth.png
// module id = SjQv
// module chunks = 1